import { AppFilters } from "@/UI/components/extFilter/AppFilters";
import { Vue } from "vue-property-decorator";
import { RouterNameEnum } from "@/router/router.types";
import { appPaginationStore } from "@/store/modules/appPagination";
import { RouterProperties } from "@/router/routerProperties";
import {AppStateStore} from "@/store/modules/appState";

type FilterType =
    | "input"
    | "select"
    | "source"
    | "sourceVuex"
    | "cascader"
    | "levelcode"
    | "datetime"
    | "date"
    | "datetimerange"
    | "checkboxButton"
    | "range-input"
    | "auto_complete"

export interface FilterList {
    key: number;
    key2?: number;
    type: FilterType;
    label: string;
    placeholder?: string | string[];
    defaultValue?: any;
    style?: string,
    value?: any;
    fieldNames?: any;
    modelName?: string;
    default_value?: any
    sel_op_first?: string
    sel_op_second?: string
    searchFieldName?: string;
    storeSource?: AppFilters;
    vuexSource?: string;
    noDataTag?:boolean;
    storeVuexSource?: string;
    filtered?: boolean;
    source?: any;
    disabledDate?: any;

    ok?(value: any): void;
    okRange?(key1: any, key2: any): void;
    options?: Array<{ value: any; label: string }>;
    onChange?(source: any): void;
    onSearch?(value: any): void;
    onScroll?(value: any): void;
    onFocus?(): void
}

export function getRouteFilterObject():any{
    return Vue.router.currentRoute.params['filter']
}

export function getRouteFilter(value:string):string{
    let result = ''
    if ('filter' in Vue.router.currentRoute.params) {
        const data = JSON.parse(Vue.router.currentRoute.params['filter'])

        if (value in data) {
            result= data[value]
        }
    }
    return result
}
export function updateRouterParams( newParams:any|string):void {
    const currentParams = Vue.router.currentRoute.params;

    //const mergedParams = { ...currentParams, newParams };
    currentParams.filter = newParams

    Vue.router.push({ params: currentParams }).then();
}

export function setRouteFilter(source: string, value: any, proxyData:boolean): void {

    let location = "";
    //var status = (age >= 18) ? "adult" : "minor";
    const params = ((Vue.router.currentRoute.params!==undefined) && (Vue.router.currentRoute.params['filter']!==undefined)) ? Vue.router.currentRoute.params['filter'] : null

    if (value[Object.keys(value)[0]] === '0' || value[Object.keys(value)[0]] === 0) {
        value = {}
    }

    let allowReplace = false
    if (params === null) allowReplace = true

    if (params!== null) {
        const check = JSON.parse(params)
        if ( check!==value) {
            allowReplace = true
        }
    } else
    {
        allowReplace = true
    }

    if (allowReplace) {

        //TODO::Описание правил маршрутов в фильтрах обязательно для устанения ошибок
        if (source === RouterProperties.salons) location = RouterNameEnum.SalonsPage;
        if (source === RouterProperties.ClientDetailNotes) location = RouterNameEnum.ClientDetailNotesPage;
        if (source === RouterProperties.clients) location = RouterNameEnum.ClientsPage;
        if (source === RouterProperties.listedProducts) location =  RouterNameEnum.ListedProductsPage;
        if (source === RouterProperties.services) location = RouterNameEnum.ServicesPage;

        if (allowReplace){
            Vue.router.replace({
                name: location,
                params: {
                    page: "1",
                    total: appPaginationStore.PageParams.total.toString(),
                    filter: JSON.stringify(value),
                },
            }).then();
            if (proxyData) AppStateStore.setProxy(true)
        }
    }

}

export class FiltersData {
    filters: FilterList[];
    filtered_values?: Record<string, any>;


    addItem(item: FilterList): void {
        this.filters.push(item);
    }

    constructor() {
        this.filters = [];
    }
}

export interface TableColumnFilter {
    text: string;
    value: any;
}

export interface ColumnFilterItem {
    text?: string;
    value?: string;
    children?: any;
}

export declare type SortOrder = "ascend" | "descend";
